<div class="container">
  <div class="container-inventory">

    <div class="header">
      <h1 class="title">{{ 'OUR_POLICIES' | translate }}</h1>
    </div>

    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>

    <ng-container *ngIf="reloadPolicies">

      <div class="form-card">
        <app-terms-and-conditions (refresh)="refreshPolicies()"></app-terms-and-conditions>
      </div>

      <div class="form-card">
        <app-privacy-policy (refresh)="refreshPolicies()"></app-privacy-policy>
      </div>

      <div class="form-card">
        <app-online-policy (refresh)="refreshPolicies()"></app-online-policy>
      </div>

    </ng-container>

  </div>
</div>